/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Include_Suspended_HintInputs */



/**
* | output |
* | --- |
* | "Their bills that were not invoiced yet, and for usage the days they were suspended, are hidden on every other billing screen. Tick this to include them. Thei..." |
*
* @param {Admin_Export_Include_Suspended_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_include_suspended_hint = /** @type {((inputs?: Admin_Export_Include_Suspended_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Include_Suspended_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre noch nicht abgerechneten Rechnungen und, bei der Nutzung, die Tage ihrer Sperre sind auf allen anderen Abrechnungsseiten ausgeblendet. Ankreuzen, um sie einzuschließen. Ihre abgerechneten Rechnungen sind immer enthalten.")
	return /** @type {LocalizedString} */ ("Their bills that were not invoiced yet, and for usage the days they were suspended, are hidden on every other billing screen. Tick this to include them. Their invoiced bills are always in.")
});